import { Container, ContainerType, Spacer, SpacerVariant, spacerOptionsAll } from "../components/layout"
import Image, { AspectRatio } from "../Image"
import Typography, { TypographyElement } from "../RedesignTypography"

import { Color } from "../components/typography"
import React from "react"
import { types } from "react-bricks/frontend"

interface AboutLaVitaProps {
    spacerTop?: SpacerVariant
    spacerBottom?: SpacerVariant
    headline: TypographyElement[]
    text: TypographyElement[]
}

const AboutLaVita = ({ spacerTop, spacerBottom }: AboutLaVitaProps) => {
    return (
        <>
            <Container type={ContainerType.Redesign}>
                <Spacer variant={spacerTop} />
                <div className="sm:grid sm:grid-cols-12 sm:gap-x-3.75 lg:gap-x-5">
                    <Image
                        maxWidth={588}
                        aspectRatio={AspectRatio["4/5"]}
                        propName="imageDesktop"
                        className="col-span-5 hidden w-full rounded-4xl md:block lg:rounded-5xl xl:rounded-6xl"
                    />
                    <div className="col-span-10 col-start-2 flex flex-col justify-center md:col-span-6 md:col-start-7 xl:col-span-5 xl:col-start-7">
                        <Typography propName="headline" allowList={["S1"]} />
                        <Color>
                            <Typography
                                propName="text"
                                size="P1"
                                allowList={["link", "bold", "italic", "small", "sup", "ul", "cl"]}
                            />
                        </Color>
                    </div>
                </div>
                <div className="hidden md:block">
                    <Spacer variant={spacerBottom} />
                </div>
            </Container>
            <Image
                maxWidth={1023}
                aspectRatio={AspectRatio["3/2"]}
                propName="imageTablet"
                className="mt-[118px] hidden w-full sm:block md:hidden"
            />
            <Image
                maxWidth={767}
                aspectRatio={AspectRatio["1/1"]}
                propName="imageMobile"
                className="mt-20 w-full sm:hidden"
            />
        </>
    )
}

AboutLaVita.schema = {
    name: "AboutLaVita",
    label: "About LaVita",
    previewImageUrl: `${process.env.IMG_CDN_URL_ASSETS}/lavita.de/startseite/screenshots_bricks/AboutLaVita.png`,
    sideEditProps: [
        {
            groupName: "Spacer",
            props: [
                {
                    name: "spacerTop",
                    label: "Spacer Top",
                    type: types.SideEditPropType.Select,
                    selectOptions: {
                        options: spacerOptionsAll,
                        display: types.OptionsDisplay.Select,
                    },
                },
                {
                    name: "spacerBottom",
                    label: "Spacer Bottom",
                    type: types.SideEditPropType.Select,
                    selectOptions: {
                        options: spacerOptionsAll,
                        display: types.OptionsDisplay.Select,
                    },
                },
            ],
        },
    ],
    getDefaultProps: (): AboutLaVitaProps => ({
        headline: [
            {
                type: "h2",
                children: [
                    {
                        text: "Lorem ipsum dolor sit amet",
                        S1: true,
                    },
                ],
            },
        ],
        text: [
            {
                type: "paragraph",
                children: [
                    {
                        text: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.",
                    },
                ],
            },
        ],
        spacerTop: SpacerVariant.XL,
        spacerBottom: SpacerVariant.XL,
    }),
}

export default AboutLaVita
